import "./sidebar.scss";

import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";

const SidebarGroup = React.forwardRef((props, ref) => (
  <div ref={ref} className={`sidebarGroup ${props.position} ${props.border ? "border" : ""}`}>
    {props.children}
  </div>
));

SidebarGroup.displayName = "SidebarGroup";

SidebarGroup.propTypes = {
  children: PropTypeShapes.elementOrArray.isRequired,
  position: PropTypes.string.isRequired,
  border: PropTypes.bool
};

export default SidebarGroup;
